import { render, staticRenderFns } from "./countryFlagSvg.vue?vue&type=template&id=0b64869b&"
import script from "./countryFlagSvg.vue?vue&type=script&lang=js&"
export * from "./countryFlagSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports